/**
 * AiGeneratedLabel — EU AI Act Art 50 disclosure label.
 * Renders a localized "This image was created by AI using your photo." line
 * on every AI portrait result view (avatar, star-persona, past-lives, couple).
 *
 * B.6 requirement: visible label on all miniapp portrait display views.
 */
import { useTranslation } from 'react-i18next';

export function AiGeneratedLabel(): JSX.Element {
  const { t } = useTranslation('flows');
  return (
    <p
      data-testid="ai-generated-label"
      style={{
        fontSize: 12,
        opacity: 0.6,
        margin: '8px 0',
        lineHeight: 1.4,
        fontFamily: 'var(--font-body, sans-serif)',
        color: 'var(--cream-dim, rgba(245,233,199,0.7))',
      }}
    >
      {t('avatarFlow.aiLabel')}
    </p>
  );
}
